/* angular:styles/component:scss;740c1cebca3a222fb338c42650e3f98d046a2080f2a3cc06fa4c3a87666ff65a;/home/vsts/work/1/s/Autocare.Api/ClientApp/src/app/module/service-provider/custom-checkbox.ts */
.custom-checkbox {
  cursor: pointer;
}
.checkbox-container {
  display: flex;
  align-items: center;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 16px;
  transition:
    border-color 0.3s ease,
    background-color 0.3s ease,
    color 0.3s ease;
  height: 52px;
  width: 100%;
}
.checkbox-container:hover {
  border-color: #666564;
}
.checkbox-box {
  width: 20px;
  height: 20px;
  border: 2px solid #d0d5dd;
  border-radius: 4px;
  background-color: #fff;
  position: relative;
  flex-shrink: 0;
  margin-right: 10px;
  transition: border-color 0.3s ease, background-color 0.3s ease;
}
.checkbox-box .checkmark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-bottom: 2px solid #fff;
  border-right: 2px solid #fff;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.checkbox-container.checked .checkbox-box {
  background-color: #FFC680;
  border-color: #FFC680;
}
.checkbox-container.checked label {
  color: #AA5D00;
}
.checkbox-container.checked {
  background-color: #FFF1E0;
  border-color: #FFF1E0;
  color: #AA5D00;
}
/*# sourceMappingURL=custom-checkbox-QMRMD3YN.css.map */
